import Icon from '@mdi/react';
import { mdiApple } from '@mdi/js';
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  GOOGLE_PLAY_ICON_URL,
  DOWNLOAD_SECTION_TITLE,
  DOWNLOAD_SECTION_SUBTITLE,
  APP_STORE_TEXT,
  GOOGLE_PLAY_TEXT,
} from '../../shared/constants';

interface DownloadSectionProps {
  isMobile: boolean;
}

function DownloadSection({ isMobile }: DownloadSectionProps) {
  return (
    <div style={styles(isMobile).downloadSection} data-download-section>
      <h2 style={styles(isMobile).downloadTitle}>{DOWNLOAD_SECTION_TITLE}</h2>
      <p style={styles(isMobile).downloadSubtitle}>
        {DOWNLOAD_SECTION_SUBTITLE}
      </p>

      <div style={styles(isMobile).downloadButtons}>
        <a
          href={APP_STORE_URL}
          style={styles(isMobile).downloadBtn}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0px)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
          }}
        >
          <Icon path={mdiApple} size={1.5} color="#1e293b" />
          <div style={styles(isMobile).btnText}>
            <div style={styles(isMobile).btnSmall}>{APP_STORE_TEXT.small}</div>
            <div style={styles(isMobile).btnLarge}>{APP_STORE_TEXT.large}</div>
          </div>
        </a>

        <a
          href={GOOGLE_PLAY_URL}
          style={styles(isMobile).downloadBtn}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0px)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
          }}
        >
          <img
            src={GOOGLE_PLAY_ICON_URL}
            alt="Google Play"
            style={{ width: '28px', height: '28px' }}
          />
          <div style={styles(isMobile).btnText}>
            <div style={styles(isMobile).btnSmall}>{GOOGLE_PLAY_TEXT.small}</div>
            <div style={styles(isMobile).btnLarge}>{GOOGLE_PLAY_TEXT.large}</div>
          </div>
        </a>
      </div>
    </div>
  );
}

export default DownloadSection;

const styles = (isMobile: boolean) => ({
  downloadSection: {
    padding: isMobile ? '60px 20px' : '80px 20px',
    textAlign: 'center' as const,
    maxWidth: '800px',
    margin: '0 auto',
  },

  downloadTitle: {
    fontSize: isMobile ? '2.5rem' : '3rem',
    fontWeight: '800',
    margin: '0 0 16px 0',
    color: '#fc2c03',
  },

  downloadSubtitle: {
    fontSize: '1.25rem',
    color: '#64748b',
    margin: '0 0 50px 0',
  },

  downloadButtons: {
    display: 'flex',
    gap: isMobile ? '20px' : '30px',
    justifyContent: 'center',
    margin: '0 0 40px 0',
    flexDirection: (isMobile ? 'column' : 'row') as 'column' | 'row',
    alignItems: 'center',
  },

  downloadBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 20px',
    background: 'white',
    border: '1px solid rgba(30, 41, 59, 0.2)',
    borderRadius: '8px',
    textDecoration: 'none',
    color: '#1e293b',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    minWidth: '180px',
    width: isMobile ? '100%' : 'auto',
    maxWidth: isMobile ? '280px' : 'none',
  },

  btnText: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
  },

  btnSmall: {
    fontSize: '0.8rem',
    opacity: 0.8,
    fontWeight: '400',
  },

  btnLarge: {
    fontSize: '1.2rem',
    fontWeight: '700',
  },
});
